import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faPlus} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { commonAPI } from "../services/CommonAPIService";
import { ToastContainer, toast } from 'react-toastify';
import { ErrorSource } from "../common/constants";



function TemplateKey() {
    const [Loading, setLoading] = useState(false);
    const [GetTemplateData, setGetTemplateData] = useState("");
    const [TemplateKeyInput, setTemplateKeyInput] = useState("");
    const [TemplateKeyId, setTemplateKeyId] = useState("");
    const [ShowHideBtn, setShowHideBtn] = useState(false);


    const GetTemplateKey = async () => {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      try {
          setLoading(true);
          let response = await commonAPI("GetTemplateKeys")
          if (response?.success === true){
              console.log("GetTemplateData", response)
              setGetTemplateData(response?.data);
              setLoading(false);
          }else{
              toast.error("Something went wrong");
              setLoading(false);
          }

      } catch (error) {
          console.log(error);
          setLoading(false);
          const bodyError = { 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber, // Need to be change
              "requestJSON": null,
              "uri": "/api/Notification/TemplateKeys",
              "errorNumber": "GTK01",
              "errorSource": ErrorSource,
              "errorSummary": error?.message,
              "errorDescription": error?.message,
              "fileClassName": "TemplateKey.js",
              "functionName": "GetTemplateKey",
          };
          let response = await commonAPI("ErrorLogMaster", bodyError)
         
          if(response?.success === true && response?.message?.length == null){
              toast.error("Something went wrong");
              setLoading(false); 
          }else{
              toast.error("Something went wrong");
              setLoading(false); 
          }
      }

    }

  useEffect(() => {
    GetTemplateKey();
  }, []);

  const addTemplateKey = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyData = {
        templateKey: TemplateKeyInput,
        createdUserId: JSON.stringify(myUserData?.userId),
    }
    try {
        setLoading(true);
        if(!TemplateKeyInput){
            toast.warning("Please enter template key");
            setLoading(false);
        }else{
          console.log("bodyData", bodyData)
            setLoading(true);
            let response = await commonAPI("AddUpdateTemplateKeys", bodyData)
            console.log(response);
            if(response?.success === true){
                toast.success("Template key added"); 
                setLoading(false);
                GetTemplateKey();
                setTemplateKeyInput("")
            }else{
                toast.error(response.message[0]);
                setLoading(false);
            }
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Notification/TemplateKeys",
              "errorNumber": "ATK01",
              "errorSource": ErrorSource,
              "errorSummary": error?.message,
              "errorDescription": error?.message,
              "fileClassName": "TemplateKey.js",
              "functionName": "addTemplateKey",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  };

  const setInputValue = (item) => {
    console.log("Template Item", item)
    setTemplateKeyInput(item?.templateKey);
    setTemplateKeyId(item?.templateKeyId)
  };

  const UpdateTemplateKey = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyData = {
        isActive: true,
        templateKeyId: TemplateKeyId,
        templateKey: TemplateKeyInput,
        modifiedUserId: JSON.stringify(myUserData?.userId),
    }
    try {
        setLoading(true);
        if(!TemplateKeyInput){
            toast.warning("Please enter template key");
            setLoading(false);
        }else{
            console.log("bodyData", bodyData)
            setLoading(true);
            let response = await commonAPI("AddUpdateTemplateKeys", bodyData)
            console.log(response);
            if(response?.success === true){
                toast.success("Template key updated"); 
                setLoading(false);
                GetTemplateKey();
                setTemplateKeyInput("")
                setTemplateKeyId("")
                setShowHideBtn(false)
            }else{
                toast.error(response.message[0]);
                setLoading(false);
            }
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/Notification/TemplateKeys",
              "errorNumber": "ATK01",
              "errorSource": ErrorSource,
              "errorSummary": error?.message,
              "errorDescription": error?.message,
              "fileClassName": "TemplateKey.js",
              "functionName": "UpdateTemplateKey",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  };
  
    
  return (
    <> 
    {Loading && (
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
      )}
      <ToastContainer />
<div className="row mb-1" style={{ alignItems:'center' }}>
        <div className="col-md-4 mt-5 pt-2">
          <div className="HeadingTop">
            <h3> Template Key   </h3>
            <span> Manage and customize predefined templates for various communications.</span>
          </div>
        </div>
        <div className="col-md-3 offset-md-5 text-right">

        </div>
      </div>
      <div className="row mb-3" style={{ alignItems:'center'}}>
             <div className="col-lg-6 col-md-6 col-sm-12 col-12">
               <div className="tempkey bg-white" >
                 <div className="inkey">
                     <span> Template Key </span>
                 </div>
                  <div className="templateKeyDiv">
                    {GetTemplateData
                      ? GetTemplateData.map((item, index) => (
                        <div className="key" key={index} style={{borderBottom: "1px solid #efefef", paddingTop: 5, paddingBottom: 5}}>
                          <span> {item?.templateKey} </span>
                          <FontAwesomeIcon icon={faEdit} className="editNotice pt-0" onClick={() => {setInputValue(item); setShowHideBtn(true)}} />
                        </div>   
                    )):null}
                  </div>
                 {/* <div className="key">
                     <span> OTP </span>
                     <FontAwesomeIcon icon={faEdit} className="editNotice" />
                 </div>
                 <div className="key">
                     <span> Forgett Password </span>
                     <FontAwesomeIcon icon={faEdit} className="editNotice" />
                 </div> */}
                 <div className="key" style={{position: "absolute", bottom: 5, left: 22, right: 22}}>
                 <input type="text" placeholder="Template Key" class="form-control required" aria-required="true" value={TemplateKeyInput} onChange={(e)=>{setTemplateKeyInput(e.target.value)}} />
                 
                 <Button  className="createClr bg-secondary" onClick={()=>{setTemplateKeyInput(""); setTemplateKeyId(""); setShowHideBtn(false)}}>
                 Cancel                       </Button>{" "}
                 {!ShowHideBtn ?
                  <Button  className="createClr" onClick={addTemplateKey}>
                    {" "}<FontAwesomeIcon icon={faPlus} />   Add                       </Button>
                  :null}  
                  {ShowHideBtn ?
                    <Button  className="createClr" onClick={UpdateTemplateKey}>
                        Update                       </Button>
                  :null}    
                 </div>
               </div>
             </div>
        </div>
 

     
 
     
</>
  );
}
export default TemplateKey;
